var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFsTab(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "g2448"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2450"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9477_163973",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clipPath2456"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2454",
    d: "M0 0H20V20H0V0Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9477_163973)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2452"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2458"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2460",
    d: "M17.8898 5.43379C17.8802 4.92547 17.871 4.44523 17.871 3.9807C17.871 3.61672 17.576 3.32168 17.212 3.32168C14.3936 3.32168 12.2477 2.51164 10.4591 0.772538C10.2032 0.52367 9.79601 0.523788 9.54023 0.772538C7.75175 2.51164 5.60628 3.32168 2.78808 3.32168C2.4241 3.32168 2.12902 3.61672 2.12902 3.9807C2.12902 4.44535 2.11992 4.92574 2.11015 5.43418C2.01984 10.1648 1.89613 16.6436 9.78378 19.3777C9.85375 19.4019 9.92668 19.4141 9.9996 19.4141C10.0725 19.4141 10.1455 19.4019 10.2154 19.3777C18.1037 16.6435 17.9802 10.1645 17.8898 5.43379Z",
    stroke: "#172B4D",
    strokeWidth: 1.32,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2462"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2464",
    d: "M11.1676 8.63531V6.16379H8.8291V8.63531H6.35742V10.9738H8.8291V13.4453H11.1676V10.9738H13.6389V8.63531H11.1676Z",
    stroke: "#172B4D",
    strokeWidth: 1.32,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFsTab);
export default __webpack_public_path__ + "static/media/fsTab.93c7f82fcd1cc1eb5132bc43a9a4ada7.svg";
export { ForwardRef as ReactComponent };